import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {VM} from '@hetao/scratch-core';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import {useCategoryVisibility} from '../lib/use-extension-category-visibility';
import {isTeacherMode} from '../lib/hetao-mode';

import extensionLibraryContent from '../lib/libraries/extensions/index.jsx';

// import analytics from '../lib/analytics';
import LibraryComponent from '../components/library/library.jsx';
import extensionIcon from '../components/action-menu/icon--sprite.svg';

const messages = defineMessages({
    extensionTitle: {
        defaultMessage: 'Choose an Extension',
        description: 'Heading for the extension library',
        id: 'gui.extensionLibrary.chooseAnExtension'
    },
    extensionUrl: {
        defaultMessage: 'Enter the URL of the extension',
        description: 'Prompt for unoffical extension url',
        id: 'gui.extensionLibrary.extensionUrl'
    }
});

class ExtensionLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }
    handleItemSelect (item) {
        const id = item.extensionId;
        let url = item.extensionURL ? item.extensionURL : id;
        if (!item.disabled && !id) {
            // eslint-disable-next-line no-alert
            url = prompt(this.props.intl.formatMessage(messages.extensionUrl));
        }
        if (id && !item.disabled) {
            if (this.props.vm.extensionManager.isExtensionLoaded(url)) {
                this.props.onCategorySelected(id);
            } else {
                this.props.vm.extensionManager.loadExtensionURL(url).then(() => {
                    this.props.onCategorySelected(id);
                });
            }
        }
        // let gaLabel = '';
        // if (typeof (item.name) === 'string') {
        //     gaLabel = item.name;
        // } else {
        // Name is localized, get the default message for the gaLabel
        //     gaLabel = item.name.props.defaultMessage;
        // }
        // analytics.event({
        //     category: 'library',
        //     action: 'Select Extension',
        //     label: gaLabel
        // });
    }
    render () {
        const {categoryVisibility} = this.props;
        
        // 根据 categoryVisibility 过滤扩展
        let extensionLibraryThumbnailData = extensionLibraryContent.map(extension => ({
            rawURL: extension.iconURL || extensionIcon,
            ...extension
        }));
        // 如果有 categoryVisibility 数据，根据可见性过滤或标记扩展
        if (!isTeacherMode() && categoryVisibility && categoryVisibility.length > 0) {
            extensionLibraryThumbnailData = extensionLibraryThumbnailData.map(extension => {
                const visibility = categoryVisibility.find(v => v.id === extension.extensionId);
                if (visibility) {
                    return {
                        ...extension,
                        disabled: !visibility.visible
                    };
                }
                return extension;
            }).filter(extension => !extension.disabled)
        }
        
        return (
            <LibraryComponent
                data={extensionLibraryThumbnailData}
                filterable={false}
                id="extensionLibrary"
                title={this.props.intl.formatMessage(messages.extensionTitle)}
                visible={this.props.visible}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

ExtensionLibrary.propTypes = {
    categoryVisibility: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        visible: PropTypes.bool
    })),
    intl: intlShape.isRequired,
    onCategorySelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    toolboxXML: PropTypes.string,
    visible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired // eslint-disable-line react/no-unused-prop-types
};

// HOC 包装器：使用 hook 并将结果传递给 ExtensionLibrary 组件
const WithCategoryVisibility = (WrappedComponent) => {
    return function CategoryVisibilityWrapper(props) {
        const categoryVisibility = useCategoryVisibility(props.toolboxXML);
        return <WrappedComponent {...props} categoryVisibility={categoryVisibility} />;
    };
};

export default WithCategoryVisibility(injectIntl(ExtensionLibrary));
